<template>
  <div class="x-flex x-rela  x-p-l-10 x-p-r-10" style="  padding-top: 5px;background-color: #ebedf6;">
    <div class="bgc-f x-w30  x-flex x-row-center x-m-r-4 x-cur-poi box-shadow" @click="scrollLeft"
      style="border-right: 1px solid #e5e5e5;height: 100%;">
      <i class="el-icon-arrow-left x-p-l-10  x-p-r-10"></i>
    </div>
    <div class="tabs-container  x-flex-1" v-horizontal-scroll ref="tabsContainer">
      <div class="tag x-flex box-shadow" size="medium" :closable="index > 0" v-for="(item, index) in tagsData"
        :key="item.path" @mouseenter="hoverIndex = index" @click="goPath(item.path)" @close="close(index)"
        :class="item.title == $route.meta.title ? 'act-tag' : ''">
        <!-- <div class="x-m-r-10"> -->
        <!-- <img @click="refresh(item.path)" v-if="item.title == $route.meta.title" src="@/assets/img/vip/Refresh-1.png"
          alt="" style="width: 14px;height: 14px;margin-right: 5px;cursor: pointer;">
        <img @click="refresh(item.path)" v-else src="@/assets/img/vip/Refresh.png" alt=""
          style="width: 14px;height: 14px;margin-right: 5px;cursor: pointer;"> -->
        <!-- </div> -->
        <!-- <div class="cir"></div> -->
        <i class="el-icon-refresh-right x-p-r-5" @click="refresh(item.path)"></i>
        {{ item.title }}
        <i class="el-icon-close" @click="close(index)" v-if="index > 0"></i>
      </div>
      <!-- <el-tabs v-model="editableTabsValue" type="card"  @tab-remove="removeTab">
      <el-tab-pane
        v-for="(item, index) in tagsData"
        :key="item.name"
        :label="item.title"
        :name="item.name"
        :closable="index > 0">
        {{item.content}}
      </el-tab-pane>
    </el-tabs> -->
    </div>
    <div class="bgc-f x-w30  x-flex x-row-center x-m-l-5 x-m-r-4 x-cur-poi box-shadow" @click="scrollRight"
      style="border-right: 1px solid #e5e5e5;height: 100%;  ">
      <i class="el-icon-arrow-right  "></i>
    </div>
    <div class="bgc-f  x-flex x-row-center box-shadow x-cur-poi" style="height: 100%;">
      <!-- <i class="el-icon-arrow-down x-p-l-10 x-p-r-10 x-cur-poi" @click="rightClick($event, selectedTabIndex)"></i> -->
      <TagsMenuVue v-show="true" :clientX="clientX" :clientY="clientY" :clickIndex="clickIndex"
        :tagsLength="tagsData.length" @fn="clickMenu" />
    </div>


  </div>
</template>

<script>
  import TagsMenuVue from "./TagsMenu.vue";
  export default {
    components: {
      TagsMenuVue,
    },
    directives: {
      "horizontal-scroll": {
        bind: function(el) {
          el.addEventListener("wheel", function(event) {
            event.preventDefault();
            el.scrollLeft += event.deltaY;
          });
        },
      },
    },
    data() {
      return {
        tagsData: [{
          title: "系统首页",
          path: "/home",
        }, ],
        isShowTagsMenu: false,
        clientX: 0,
        clientY: 0,
        clickIndex: 0,
        hoverIndex: 0,
        editableTabsValue: "home",
      };
    },
    computed: {
      activeTabIndex() {
        return this.tagsData.findIndex(item => item.path === this.$route.path);
      },
      // selectedTabIndex() {
      //   this.clickIndex = this.tagsData.findIndex(item => item.title === this.$route.meta.title);
      //   // 根据 $route.meta.title 获取选中的 tabs 索引
      //   return this.clickIndex
      // }
    },
    watch: {
      clickIndex(e) {},
      $route: {
        immediate: true,
        handler(val) {
          const bool = this.tagsData.find((item, index) => val.path == item.path);


          if (!bool) {
            this.tagsData.push({
              title: val.meta.title,
              path: val.path,
            });
            this.clickIndex = this.tagsData.findIndex(item => item.title === val.meta.title);
          }

          this.$nextTick(() => {
            const container = this.$refs.tabsContainer;
            const activeTab = container.querySelector('.act-tag'); // 找到当前激活的 tab

            if (activeTab) {
              activeTab.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
              }); // 使用 scrollIntoView 实现平滑滚动
            }
          });
        },
      },
    },

    mounted() {
      // 给文档新增点击事件
      document.addEventListener("click", this.closeMenus);
    },
    methods: {
      init() {
        // 页面初始化逻辑
      },
      refresh(path) {
        if (path === this.$route.path) {
          console.log(path);
          this.$emit('refresh-page', path);
        } else {
          this.$router.push(path);
          this.$nextTick(() => {
            this.$emit('refresh-page', path);
          });
        }
      },
      scrollLeft() {
        const container = this.$refs.tabsContainer;
        container.scrollLeft -= 100; // 每次向左滚动100px
      },
      scrollRight() {
        const container = this.$refs.tabsContainer;
        container.scrollLeft += 100; // 每次向右滚动100px
      },
      // 点击标签跳转
      goPath(path) {
        // 解决重复点击会报错，数据冗余
        if (path !== this.$route.path) {
          this.$router.push(path);
        }
        this.clickIndex = this.tagsData.findIndex(item => item.path === path);
        this.closeMenus();
      },
      // 关闭选择菜单
      closeMenus() {
        this.isShowTagsMenu = false;
      },
      //   点击操作之后实现
      clickMenu(i) {
        // 关闭其他，就保留自己的包含系统首页
        if (i === 0) {
          // 关闭其他，前提是保留系统首页
          let clickItem = [];
          clickItem = this.tagsData.filter(
            (item, index) => index === this.clickIndex
          );
          const newTags = [{
            title: "系统首页",
            path: "/home"
          }, ...clickItem];
          if (newTags[1].path == "/home") {
            this.tagsData = [{
              title: "系统首页",
              path: "/home"
            }];
          } else {
            this.tagsData = [{
              title: "系统首页",
              path: "/home"
            }, ...clickItem];
          }
          const activePath =
            newTags[1].path === "/home" ? "/home" : newTags[1].path;
          this.goPath(activePath);
        }
        // else if (i === 1) {
        //   // 关闭左侧
        //   this.tagsData.splice(1, this.clickIndex - 1);
        // } else if (i === 2) {
        //   // 关闭右侧
        //   this.tagsData.splice(this.clickIndex + 1);
        //   this.goPath(this.tagsData[this.clickIndex].path);
        // }
        else if (i === 1) {
          // 全部关闭
          // 1 处理数组
          this.tagsData = [{
            title: "系统首页",
            path: "/home",
          }, ];
          // 跳转到系统首页
          this.goPath("/home");
        } else if (i === 2) { // 新增关闭当前页签
          const currentIndex = this.clickIndex;
          this.close(currentIndex);
        }
      },
      close(i) {
        if (
          this.tagsData[i].path == this.$route.path &&
          i !== this.tagsData.length - 1
        ) {
          // 直接跳转到最后一项了
          this.$router.push(this.tagsData[this.tagsData.length - 1].path);
          this.clickIndex = this.tagsData.findIndex(item => item.path === this.$route.path);
        } else if (i === this.tagsData.length - 1) {
          this.$router.push(this.tagsData[this.tagsData.length - 2].path);
          this.clickIndex = this.tagsData.findIndex(item => item.path === this.$route.path);
        }
        // 关闭当前项，本质上就是删除tags的对应项
        this.tagsData.splice(i, 1);
        this.closeMenus();
      },
      // 右键点击
      rightClick(e, i) {
        this.isShowTagsMenu = true;
        this.clientX = e.clientX;
        this.clientY = e.clientY;
        this.clickIndex = i;

      },
    },
  };
</script>
<style lang="scss" scoped>
  .tabs-container {
    width: 100%;
    height: 100%;

    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    display: flex;
    scroll-behavior: smooth; // 新增：新增平滑滚动效果
  }

  .tag {
    cursor: pointer;
    margin-right: 5px;
    height: 100%;
    line-height: 34px;
    font-size: 14px;
    transition: all 0.3s ease-in-out;

    .cir {
      width: 8px;
      height: 8px;
      margin-right: 4px;
      background-color: #808080;
      border-radius: 50%;
      display: inline-block;
    }
  }

  .tag {
    background-color: #fff;
    border-color: none;
    padding: 0 10px;
    position: relative;

    .el-icon-close {
      margin-left: 6px;
    }



    &::after {
      width: 0;
      /* 初始宽度为0 */
      display: block;
      content: "";
      height: 2px;
      // height: 4px;
      background-color: #007AFB;
      position: absolute;
      top: 0;
      left: 50%;
      /* 从中间开始 */
      transform: translateX(-50%);
      /* 居中定位 */
      z-index: 1;
      transition: width 0.3s ease-in-out;
    }

    &:hover {
      background-color: #efefef;
    }

    // 新增悬停效果
    &:hover::after {
      // width: 30%;
      width: 100%;
      /* 悬停时扩展到100%宽度 */
    }

  }

  .act-tag {
    position: relative;
    color: #007AFB;

    // &::after {
    //   // width: 30%;
    //   width: 100%;
    //   /* 扩展到100%宽度 */
    // }
    .cir {
      background-color: #007AFB;
    }

    &::before {
      background-color: #007AFB;
    }

  }

  .el-icon-close {
    &:hover {
      color: #007AFB;
    }
  }

  .tabs-container::-webkit-scrollbar {
    display: none;
  }

  .content {
    flex: 0 0 auto;
    /* 防止内容换行 */
    padding: 10px;
  }

  .box-shadow {
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/tabs.vue